module.exports = __webpack_public_path__ + "img/img_exploration2.cef0e4b4.png";